// Page
import React from "react";
import { Container } from '@mui/material';

export const Content = ({menusWidth, pageWidth, children}) => {

  return (
    <Container maxWidth="true" sx={{
        marginTop: '20px', 
        marginLeft: `${menusWidth}px`, 
        width: menusWidth ? `${pageWidth}px` : '100%', //`${pageWidth}px`, 
        minHeight: '100vh',
        maxWidth: '100%',
        overflowX: 'auto',
        transition: 'margin-left 0.3s ease', // 애니메이션 효과 추가
        alignItems: 'center', justifyContent: 'center'}}>

        {children}

    </Container>
  );
};